import { TableOperationHeader } from '@getsynapse/design-system';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import DashboardFiltersButton from './DashboardFilters/DashboardFiltersButton';
import { DashboardContentViewOverflowMenu } from './DashboardContentViewOverflowMenu/DashboardContentViewOverflowMenu';
import { AddInsightsButton } from './AddInsightsButton';
import DashboardAppliedFiltersTags from './DashboardFilters/DashboardAppliedFiltersTags';
import { DashboardSharedOverflowMenu } from './DashboardSharedOverflowMenu';
import { dashboardSelectors } from 'state/normalized/dashboard/dashboardSlice';
import { RootState } from 'state/store';

export const DashboardContentViewHeader = (props: { gridRef: any }) => {
  const { gridRef } = props;
  const { flexibleDashboardFilters = false, flexibleDashboardShare = false } =
    useFlags();
  const currentDashboardId = useSelector(
    dashboardSelectors.selectCurrentDashboardId
  );
  const { canEdit, canShare } = useSelector((state: RootState) =>
    dashboardSelectors.selectDashboardAffordanceFlags(
      state,
      currentDashboardId ?? ''
    )
  );

  return (
    <>
      <div className='mt-4'>
        <TableOperationHeader
          hideSearch={true}
          className='border-b-1 rounded-b shadow-header'
          actionButtons={
            <>
              {canEdit && <AddInsightsButton style={`header`} />}
              {flexibleDashboardFilters && <DashboardFiltersButton />}
              {flexibleDashboardShare && canShare && currentDashboardId && (
                <DashboardSharedOverflowMenu dashboardId={currentDashboardId} />
              )}
              <DashboardContentViewOverflowMenu gridRef={gridRef} />
            </>
          }
        />
        <DashboardAppliedFiltersTags />
      </div>
    </>
  );
};
